export const fetchServices = async () => {
    return [
        {
            id: 1,
            title: 'Full Stack SaaS Platform Development and Cloud-based Deployment',
            description: 'End-to-end development of scalable, secure, and high-performance SaaS platforms.',
            content: `
  <p>We offer comprehensive <b>full-stack development services</b>, covering everything from <b>web</b> to <b>mobile applications</b>, ensuring seamless integration across platforms. Whether you need a modern web app, a scalable SaaS platform, or a high-performance mobile solution, our expert team is equipped to deliver robust, secure, and user-friendly applications.</p>
  
  <p>We specialize in a wide range of technologies and frameworks, including:</p>
  
  <div className="data__list">
      <ul>
          <li><b>Frontend Development:</b> React, Angular, Vue.js</li>
          <li><b>Backend Development:</b> Node.js, Python (Flask, Django), Java, Ruby on Rails</li>
          <li><b>Databases:</b> MongoDB, PostgreSQL, MySQL</li>
      </ul>
  </div>
  
  <p>For mobile applications, we provide both <b>native and cross-platform development</b>, using:</p>
  
  <div className="data__list">
      <ul>
          <li><b>Flutter</b> - For beautiful, high-performance apps</li>
          <li><b>React Native</b> - Efficient cross-platform development</li>
          <li><b>Swift/Kotlin</b> - Native iOS and Android development</li>
      </ul>
  </div>
  
  <p>We ensure your product is built with the latest industry standards, supporting:</p>
  
  <div className="data__list">
      <ul>
          <li><b>Cloud-based Deployments</b></li>
          <li><b>API Integrations</b></li>
          <li><b>AI-driven Automation</b></li>
          <li><b>UI/UX Design</b></li>
          <li><b>End-to-end Development & Ongoing Maintenance</b></li>
      </ul>
  </div>
  
  <p>Our <b>DevOps services</b> ensure seamless deployment, scalability, and reliability using top cloud platforms:</p>
  
  <div className="data__list">
      <ul>
          <li><b>AWS</b> - Scalable cloud infrastructure</li>
          <li><b>Azure</b> - Enterprise-grade solutions</li>
          <li><b>Firebase</b> - Real-time database & authentication</li>
      </ul>
  </div>
  
  <p>We specialize in:</p>
  
  <div className="data__list">
      <ul>
          <li><b>CI/CD Pipelines</b> - Faster release cycles</li>
          <li><b>Infrastructure Automation</b> - Streamlining deployments</li>
          <li><b>Cloud-native Development</b> - Optimized performance</li>
          <li><b>Containerization</b> - Docker & Kubernetes</li>
          <li><b>Serverless Architectures</b></li>
          <li><b>Automated Monitoring</b> - Prometheus, Grafana</li>
          <li><b>Cloud Security & Cost Optimization</b></li>
      </ul>
  </div>
  
  <p>Our team ensures that your applications remain <b>robust, secure, and cost-effective</b> in any environment.</p>
  `,
            icon: 'icon-08',
            href: '/services-details',
            data_aos_delay:'200ms',
          },
          {
          id: 2,
          title: 'Strategic Advisory for Multiphysics Simulation and Solver Interoperability',
          description: 'Consistency in posting content fosters a sense of reliability among followers.',
          content: '<p>At ERI, we specialize in guiding organizations through the complexities of multiphysics coupling and solver integration. Led by Dr. Satish Chimakurthi, a recognized expert with nearly two decades of experience in partitioned coupling methods, we help clients identify and implement the best methodologies for multiphysics simulation workflows. With expertise in ANSYS System Coupling, STAR-CCM+ & Abaqus Co-Simulation, preCICE, and LS-DYNA ALE FSI, we offer tailored guidance to enhance simulation accuracy, computational efficiency, and solver interoperability. Whether integrating in-house solvers with commercial tools or optimizing existing workflows, ERI provides expert advisory services to help clients make informed decisions and develop high-performance multiphysics solutions.</p>',
          icon: 'icon-04',
          href: '/services-details',
          data_aos_delay:'00ms',
        },
        {
            id: 4,
            title: 'Customizable Software-as-a-Service (SaaS) Solutions for UNDEX Biomechanics & Injury Modeling',
            description: 'Consistency in posting content fosters a sense of reliability among followers.',
            content: '<p>At ERI, we offer customization services for our cloud-based SaaS platform, designed to analyze the impact of underwater explosions (UNDEX) on human lung biomechanics and physiology. Our platform provides high-fidelity multiphysics simulations, integrating hydrodynamics, biomechanics, and physiological modeling to support research in Explosive Ordnance Disposal (EOD) personnel protection, injury prediction, and countermeasure development.<br/><br/>We can work with potential clients to tailor the platform to specific use cases, incorporating custom physics models, user-defined injury criteria, scenario-specific configurations, and enhanced solver integration. Whether adapting the system to different blast environments, optimizing workflows for unique research needs, or expanding compatibility with commercial solvers such as LS-DYNA, ERI provides expert platform customization services.<br/><br/>For more information, please visit <a href="https://simsolver.epitomeri.com" target="_blank" rel="noopener noreferrer"><u>SimSolver</u></a>.</p>',
            icon: 'icon-04',
            href: '/services-details',
            data_aos_delay:'00ms',
        },
        // {
        //     id: 5,
        //     title: 'AI-Driven Flight and Marine Anomaly Detection',
        //     description: 'Consistency in posting content fosters a sense of reliability among followers.',
        //   content: '<p>At ERI, we offer customization services for Tetravigil, an AI-driven SaaS platform for real-time detection, tracking, and anomaly identification across flight and maritime domains. Developed with Missile Defense Agency funding, <a href="https://aws.tetravigil.com"  target="_blank" rel="noopener noreferrer"><u>Tetravigil</u></a> uses machine learning to establish behavioral patterns and detect deviations in near real-time, supporting missile defense, maritime security, and situational awareness.<br/><br/>We can work with defense agencies, research institutions, and industry partners to tailor Tetravigil for specific needs, including custom data integration, algorithm tuning, UI enhancements, and operational scenario modeling. With an AWS-based cloud deployment, the platform provides scalable AI-driven monitoring, ensuring enhanced situational awareness and proactive threat assessment across air and sea environments.</p>',
        //   icon: 'icon-04',
        //   href: '/services-details',
        //   data_aos_delay:'00ms',
        // },
        {
            id: 6,
            title: 'Navigating SBIR & STTR Funding with Expert Insights',
            description: 'Consistency in posting content fosters a sense of reliability among followers.',
            content: '<p>At ERI, we provide expert consulting for Small Business Innovation Research (SBIR) and Small Business Technology Transfer (STTR) programs, helping businesses navigate the complexities of securing non-dilutive funding for cutting-edge research and development. With over five years of experience in developing winning proposals, we assist clients in identifying the most suitable funding opportunities, structuring competitive technical proposals, and ensuring alignment with agency priorities. Our expertise spans the entire SBIR/STTR lifecycle, from concept development and proposal writing to compliance, budgeting, and transition strategies. Whether you are a first-time applicant or an experienced small business looking to scale your innovation through federal funding, ERI offers the strategic insight needed to maximize success and accelerate commercialization.</p>',
            icon: 'icon-04',
            href: '/services-details',
            data_aos_delay:'00ms',
        }
    ];
}